const routePrefetchers: Record<string, () => Promise<unknown>> = {
  '/overview': () => import('@/pages/Overview'),
  '/trade': () => import('@/pages/Trade'),
  '/banking': () => import('@/pages/Accounts'),
  '/banking/accounts': () => import('@/pages/Accounts'),
  '/banking/transactions': () => import('@/pages/Transactions'),
  '/planning': () => import('@/pages/Planning'),
  '/vault': () => import('@/pages/Vault'),
  '/notifications': () => import('@/pages/Notifications'),
  '/settings': () => import('@/pages/Settings'),
};

export function prefetchRoute(path: string): void {
  const prefetch = routePrefetchers[path];
  if (!prefetch) {
    return;
  }

  const run = () => {
    void prefetch();
  };

  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(run);
  } else {
    setTimeout(run, 200);
  }
}
